
export default function HeroSection() {
  return (
    <section 
      id="inicio" 
      className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-teal-50 to-white overflow-hidden"
      style={{
        backgroundImage: `url('https://readdy.ai/api/search-image?query=Modern%20surgical%20robot%20in%20pristine%20white%20operating%20room%20with%20teal%20surgical%20lighting%2C%20advanced%20medical%20technology%2C%20clean%20minimalist%20environment%2C%20professional%20medical%20equipment%2C%20sterile%20atmosphere%2C%20high-tech%20precision%20instruments%2C%20futuristic%20healthcare%20setting%2C%20white%20and%20teal%20color%20scheme&width=1920&height=1080&seq=hero-surgery-robot&orientation=landscape')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}
    >
      <div className="absolute inset-0 bg-white/80"></div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 w-full">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="text-left">
            <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
              Urólogo en<span className="block" style={{ color: '#20C6B2' }}>Guadalajara</span>
            </h1>
            <p className="text-xl text-gray-600 mb-8 leading-relaxed">
              Dr. Héctor Remess, especialista en cirugía robótica y láser urológica con tecnología de vanguardia. Tratamientos mínimamente invasivos para próstata, riñones, disfunción eréctil y VPH.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <a 
                href="https://wa.me/523333958988?text=Hola%20Doctor,%20me%20gustaría%20agendar%20una%20consulta"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white px-8 py-4 rounded-xl text-lg font-semibold hover:opacity-90 transition-all duration-300 transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
                style={{ backgroundColor: '#20C6B2' }}
              >
                <i className="ri-calendar-line mr-2"></i>
                Agenda tu Consulta
              </a>
              <a 
                href="#tratamientos" 
                className="border-2 px-8 py-4 rounded-xl text-lg font-semibold hover:text-white transition-all duration-300 text-center whitespace-nowrap cursor-pointer"
                style={{ 
                  borderColor: '#20C6B2', 
                  color: '#20C6B2',
                  '&:hover': { backgroundColor: '#20C6B2' }
                }}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#20C6B2'}
                onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
              >
                Ver Tratamientos
              </a>
            </div>
            
            <div className="mt-12 grid grid-cols-3 gap-8">
              <div className="text-center">
                <div className="text-3xl font-bold" style={{ color: '#20C6B2' }}>10+ años</div>
                <div className="text-sm text-gray-600">De Experiencia</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold" style={{ color: '#20C6B2' }}>1000+</div>
                <div className="text-sm text-gray-600">Cirugías Exitosas</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold" style={{ color: '#20C6B2' }}>100%</div>
                <div className="text-sm text-gray-600">Satisfacción</div>
              </div>
            </div>
          </div>
          
          <div className="relative">
            <div className="absolute inset-0 rounded-3xl transform rotate-3 opacity-20" style={{ background: 'linear-gradient(to right, #20C6B2, #1DB5A3)' }}></div>
            <img 
              src="https://static.readdy.ai/image/f15b91f1c882dc85fb9b8fcd7db718c1/ab855bb9b8755f5d29cc499204cadde0.jpeg"
              alt="Sistema Robótico da Vinci"
              className="relative w-full h-96 object-cover object-top rounded-3xl shadow-2xl"
            />
          </div>
        </div>
      </div>
      
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-2xl" style={{ color: '#20C6B2' }}></i>
      </div>
    </section>
  );
}
